import React from 'react'
import Staff, { type StaffProps } from '../../../react4xp/components/Staff'

export default (props: StaffProps) => <Staff {...props} />